export default __webpack_public_path__ + "static/media/Conference Room- Pen and Paper.7869662a.jpg";